export default __webpack_public_path__ + "static/media/banner-bg.e47dcac0.png";